module.exports = __webpack_public_path__ + "static/media/404-background.e7e299cb.svg";